import { PlatformCode } from 'src/type/common';
import { tF } from './i18n';
import { BiMap } from './objects';

type PlatformName = '인스타그램' | '유튜브' | '네이버 블로그' | '틱톡';

export type PlatformFullName =
	| '인스타그램'
	| '유튜브'
	| '네이버 블로그'
	| '틱톡'
	| '엑스';
// 카테고리
export const insta_category: string[] = [
	'만화/애니/툰',
	'짤/밈',
	'스타/연예인',
	'문학/종교/역사',
	'영화/방송',
	'미술/디자인',
	'공연/전시',
	'음악/댄스',
	'고양이',
	'강아지',
	'기타동물',
	'육아/키즈',
	'결혼/연애',
	'홈/리빙',
	'패션',
	'뷰티',
	'F&B',
	'문구/완구',
	'건강가전',
	'다이어트/건강보조식품',
	'피트니스',
	'취미',
	'게임',
	'사진/영상',
	'스포츠',
	'여행/관광',
	'유명장소/핫플',
	'시사/이슈/정보',
	'일상',
	'교육',
	'자동차/모빌리티',
	'IT/테크',
	'브랜드공식계정',
];

export const youtube_category: string[] = [
	'스타/연예인',
	'만화/애니',
	'웹콘텐츠/웹드라마',
	'TV/방송',
	'스트리머/BJ',
	'먹방',
	'문화/예술',
	'미술/디자인',
	'공연/전시',
	'음악/댄스',
	'고양이',
	'강아지',
	'기타동물',
	'육아/키즈',
	'결혼/연애',
	'홈/리빙',
	'패션',
	'뷰티',
	'F&B',
	'문구/완구',
	'의학정보/의약품',
	'다이어트/건강보조식품',
	'피트니스',
	'취미',
	'게임',
	'사진/영상',
	'스포츠',
	'아웃도어',
	'여행/관광',
	'유명장소/핫플',
	'시사/이슈/정보',
	'금융/재테크',
	'브이로그',
	'동기부여/자기계발',
	'어학/외국어',
	'강연/강의',
	'취업/커리어',
	'자동차/모빌리티',
	'IT/테크',
	'ASMR',
	'버튜버',
	'짤/밈',
	'브랜드공식계정',
];
export const naver_category: string[] = [
	'스타/연예인',
	'만화/애니',
	'방송',
	'드라마',
	'문학/책',
	'영화',
	'미술/디자인',
	'공연/전시',
	'음악',
	'육아/결혼',
	'패션/미용',
	'인테리어/DIY',
	'요리/레시피',
	'상품리뷰',
	'원예/재배',
	'건강/의학',
	'애완/반려동물',
	'취미',
	'게임',
	'스포츠',
	'사진',
	'국내여행',
	'세계여행',
	'맛집',
	'사회/정치',
	'비즈니스/경제',
	'일상/생각',
	'좋은글/이미지',
	'어학/외국어',
	'교육/학문',
	'IT/컴퓨터',
	'자동차',
];
export const tiktok_category: string[] = [
	'먹방',
	'댄스/음악',
	'방송/미디어',
	'예술/공예',
	'애완동물',
	'결혼/연애',
	'뷰티',
	'식품/요리',
	'유아/키즈',
	'패션',
	'홈리빙/가전제품',
	'건강/웰니스',
	'헬스/홈트/요가/필라테스',
	'게임',
	'사진/영상',
	'스포츠/아웃도어',
	'취미/놀이',
	'맛집/핫플',
	'여행/관광',
	'금융/재테크',
	'시사/이슈/정보',
	'일상/코미디',
	'교육/훈련',
	'IT/테크',
	'디지털기기',
	'자동차/교통수단',
];

// 브랜드 카테고리
export const instagram_brand_category: string[] = [
	'동물',
	'디지털',
	'라이프스타일',
	'뷰티',
	'스포츠',
	'엔터테인먼트',
	'여행',
	'예술',
	'키즈',
	'패션',
	'팬시완구',
	'푸드',
	'홈리빙',
];

export const platform_brand_category_mapper: Record<PlatformCode, string[]> = {
	// 브랜드 카테고리 확장성 고려
	ig: instagram_brand_category,
	yt: instagram_brand_category,
	nb: instagram_brand_category,
	tt: instagram_brand_category,
};

// 팔로워
export const insta_follower: string[] = [
	'0 ~ 500명 미만',
	'500 ~ 1,000명 미만',
	'1,000 ~ 2,000명 미만',
	'2,000 ~ 5,000명 미만',
	'5,000 ~ 1만 명 미만',
	'1만 ~ 3만 명 미만',
	'3만 ~ 5만 명 미만',
	'5만 ~ 10만 명 미만',
	'10만 ~ 20만 명 미만',
	'20만 ~  50만 명 미만',
	'50만 ~  100만 명 미만',
	'100만 ~  300만 명 미만',
	'300만 ~  500만 명 미만',
	'500만 명 이상',
];
export const youtube_follower: string[] = insta_follower;
export const naver_follower: string[] = [
	'0 ~ 15만 명 미만',
	'15만 ~ 30만 명 미만',
	'30만 ~ 60만 명 미만',
	'60만 ~ 150만 명 미만',
	'150만 ~ 300만 명 미만',
	'300만 ~ 600만 명 미만',
	'600만 ~ 1,000만 명 미만',
	'1,000만 ~ 2,000만 명 미만',
	'2,000만 ~ 2,500만 명 미만',
	'2,500만 ~ 3,000만 명 미만',
	'3,000만 ~ 4,500만 명 미만',
	'4,500만 ~ 7,000만 명 미만',
	'7,000만 ~ 9,500만 명 미만',
	'9,500만 명 이상',
];

export const naver_followerBiMap = new BiMap({
	'0 ~ 15만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.0'),
	'15만 ~ 30만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.1'),
	'30만 ~ 60만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.2'),
	'60만 ~ 150만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.3'),
	'150만 ~ 300만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.4'),
	'300만 ~ 600만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.5'),
	'600만 ~ 1,000만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.6'),
	'1,000만 ~ 2,000만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.7'),
	'2,000만 ~ 2,500만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.8'),
	'2,500만 ~ 3,000만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.9'),
	'3,000만 ~ 4,500만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.10'),
	'4,500만 ~ 7,000만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.11'),
	'7,000만 ~ 9,500만 명 미만': tF('infReportNaverBlog:text.units.naver_follower.12'),
	'9,500만 명 이상': tF('infReportNaverBlog:text.units.naver_follower.13'),
});

export const tiktok_follower: string[] = [
	'0 ~ 500명 미만',
	'500 ~ 1,000명 미만',
	'1,000 ~ 2,000명 미만',
	'2,000 ~ 5,000명 미만',
	'5,000 ~ 1만 명 미만',
	'1만 ~ 3만 명 미만',
	'3만 ~ 5만 명 미만',
	'5만 ~ 10만 명 미만',
	'10만 ~ 20만 명 미만',
	'20만 ~  50만 명 미만',
	'50만 ~  100만 명 미만',
	'100만 ~  300만 명 미만',
	'300만 ~  500만 명 미만',
	'500만 명 이상',
];

const instaAgeBiMap = new BiMap({
	'0 ~ 500명 미만': tF('follower-count.0'),
	'500 ~ 1,000명 미만': tF('follower-count.1'),
	'1,000 ~ 2,000명 미만': tF('follower-count.2'),
	'2,000 ~ 5,000명 미만': tF('follower-count.3'),
	'5,000 ~ 1만 명 미만': tF('follower-count.4'),
	'1만 ~ 3만 명 미만': tF('follower-count.5'),
	'3만 ~ 5만 명 미만': tF('follower-count.6'),
	'5만 ~ 10만 명 미만': tF('follower-count.7'),
	'10만 ~ 20만 명 미만': tF('follower-count.8'),
	'20만 ~  50만 명 미만': tF('follower-count.9'),
	'50만 ~  100만 명 미만': tF('follower-count.10'),
	'100만 ~  300만 명 미만': tF('follower-count.11'),
	'300만 ~  500만 명 미만': tF('follower-count.12'),
	'500만 명 이상': tF('follower-count.13'),
});

// 연령대
export const insta_age: (() => string)[] = [
	tF('utils.filter-list.insta-age.18-24'),
	tF('utils.filter-list.insta-age.25-34'),
	tF('utils.filter-list.insta-age.35-44'),
	tF('utils.filter-list.insta-age.45-54'),
	tF('utils.filter-list.insta-age.55'),
];
export const youtube_age: (() => string)[] = [
	tF('utils.filter-list.youtube-age.13-17'),
	tF('utils.filter-list.youtube-age.18-24'),
	tF('utils.filter-list.youtube-age.25-34'),
	tF('utils.filter-list.youtube-age.35-44'),
	tF('utils.filter-list.youtube-age.45-54'),
	tF('utils.filter-list.youtube-age.55'),
];
export const tiktok_age: string[] = ['18-24세', '25-34세', '35-44세', '45-54세', '55세+'];
export const ageList: string[] = ['13-17', '18-24', '25-34', '35-44', '45-54', '55'];

// 장소
export const naver_location: string[] = [
	'서울',
	'경기',
	'인천',
	'대구/경북',
	'부산/경남',
	'대전/충청',
	'광주/전라',
	'강원',
	'제주',
	'세종',
];

export const platform_category_mapper: Record<PlatformCode, string[]> = {
	ig: insta_category,
	yt: youtube_category,
	nb: naver_category,
	tt: tiktok_category,
};

export const platform_follower_mapper: Record<PlatformCode, string[]> = {
	ig: insta_follower,
	yt: youtube_follower,
	nb: naver_follower,
	tt: tiktok_follower,
};

export const platform_age_mapper: Record<PlatformCode, (string | (() => string))[]> = {
	ig: insta_age,
	yt: youtube_age,
	nb: [],
	tt: tiktok_age,
};

export const setAgeSection = (age: number | null): string => {
	if (age === null) return '';

	const age_section: (() => string)[] = [
		tF('commonTable:table-cell.text.age-group1'),
		tF('commonTable:table-cell.text.age-group2'),
		tF('commonTable:table-cell.text.age-group3'),
		tF('commonTable:table-cell.text.age-group4'),
		tF('commonTable:table-cell.text.age-group5'),
	];
	const round_age = Math.round(age);

	const resultIdx = ageList.findIndex((item, idx) => {
		if (round_age >= 55) return idx === 5;
		if (round_age < 13) return idx === 0;
		else {
			const start: number = +item.split('-')[0];
			const end = +item.split('-')[1];

			return round_age >= start && round_age <= end;
		}
	});

	if (!resultIdx) return '';
	const result = age_section[resultIdx];

	if (result) return result();
	else return '';
};

export const setFollowersText = (list: string[], platform: PlatformCode): string[] => {
	const target_list = platform_follower_mapper[platform];
	if (list.join(',') === 'all') return ['all'];

	return list.map((num) => {
		const target_idx = num.match(/[\d]{1,}/) ?? [0];

		return target_list[+target_idx[0]];
	});
};

export const setFollowerRange = (follower_count: number | null): string => {
	if (follower_count == null) return '';
	const resultItem =
		insta_follower.find((item, idx) => {
			if (follower_count >= 5000000) return idx === 13;
			else if (follower_count >= 0 && follower_count < 5000) {
				const start: number = +item.split(' ~ ')[0].replace(',', '');
				const end = +item.split(' ~ ')[1].split('명')[0].replace(',', '');
				return follower_count >= start && follower_count < end;
			} else if (follower_count >= 5000 && follower_count < 10000) return idx === 4;
			else if (follower_count >= 10000 && follower_count < 5000000) {
				const start: number = +(item.split(' ~ ')[0].replace('만', '') + '0000');
				const end: number = +(item.split(' ~ ')[1].split('만')[0] + '0000');
				return follower_count >= start && follower_count < end;
			}
		}) ?? '';

	return instaAgeBiMap.get(resultItem)?.() ?? '';
};

export const setTotalVisitorRange = (total_visitor_count: number | null): string => {
	if (total_visitor_count == null) return '';
	// return (
	// 	naver_follower.find((item, idx) => {
	// 		if (total_visitor_count >= 95000000) return idx === 13;
	// 		else if (total_visitor_count >= 0 && total_visitor_count < 150000) return idx === 0;
	// 		else if (total_visitor_count >= 150000 && total_visitor_count < 95000000) {
	// 			const start: number = +(item.split(' ~ ')[0].replace('만', '').replace(',', '') + '0000');
	//
	// 			const end = +(item.split(' ~ ')[1].replace(',', '').split('만')[0] + '0000');
	// 			return total_visitor_count >= start && total_visitor_count < end;
	// 		}
	// 	}) ?? ''
	// );
	const resultItem =
		naver_follower.find((item, idx) => {
			if (total_visitor_count >= 95000000) return idx === 13;
			else if (total_visitor_count >= 0 && total_visitor_count < 150000) return idx === 0;
			else if (total_visitor_count >= 150000 && total_visitor_count < 95000000) {
				const start: number = +(
					item.split(' ~ ')[0].replace('만', '').replace(',', '') + '0000'
				);

				const end = +(item.split(' ~ ')[1].replace(',', '').split('만')[0] + '0000');
				return total_visitor_count >= start && total_visitor_count < end;
			}
		}) ?? '';
	return naver_followerBiMap.get(resultItem)?.() ?? '';
};

export const setAgeText = (list: string[], platform: PlatformCode): string[] => {
	if (platform === 'nb') return [];
	if (list.join(',') === 'all') return ['all'];

	const target_list = platform_age_mapper[platform];
	return list.map(() => {
		return (target_list.find((item) => (typeof item === 'function' ? item() : item)) ??
			'-') as string;
	});
};

export const setFollowersDBLayout = (selected: string[], platform: PlatformCode) => {
	if (selected.join(',') === 'all') return 'all';

	return selected
		.map((item) => `${platform}_${platform_follower_mapper[platform].indexOf(item)}`)
		.join(',');
};

export const setAgeDBLayout = (selected: string[]) => {
	if (selected.join(',') === 'all') return 'all';

	return selected
		.map((item) => {
			return item.substring(0, 2);
		})
		.join(',');
};

export const platform_value: Record<PlatformName, PlatformCode> = {
	인스타그램: 'ig',
	유튜브: 'yt',
	'네이버 블로그': 'nb',
	틱톡: 'tt',
};

export const platform_name: Record<PlatformCode, PlatformName> = {
	ig: '인스타그램',
	yt: '유튜브',
	nb: '네이버 블로그',
	tt: '틱톡',
};

export const platform_full_name: Record<PlatformCode, PlatformFullName> = {
	ig: '인스타그램',
	yt: '유튜브',
	nb: '네이버 블로그',
	tt: '틱톡',
};

export const platformFullName: Record<PlatformCode, () => string> = {
	ig: tF('common:platforms.ig'),
	yt: tF('common:platforms.yt'),
	nb: tF('common:platforms.nb'),
	tt: tF('common:platforms.tt'),
};

export const platform_report_value: Record<PlatformCode, string> = {
	ig: 'instagram',
	yt: 'youtube',
	nb: 'naverblog',
	tt: 'tiktok',
};

export const gender_mapper: Record<string, () => string> = {
	F: tF('commonTable:table-cell.text.female'),
	M: tF('commonTable:table-cell.text.male'),
	여성: tF('commonTable:table-cell.text.female'),
	남성: tF('commonTable:table-cell.text.male'),
};

const gender_number_mapper = [
	tF('commonTable:table-cell.text.male'),
	tF('commonTable:table-cell.text.female'),
];

export const mapGenderType = (gender_value: string) => {
	if (Number.isNaN(+gender_value)) return gender_mapper[gender_value];
	else {
		const gender_number_idx = Math.round(+gender_value);

		return gender_number_mapper[gender_number_idx];
	}
};
